import { matchPath, useLocation } from 'react-router';
import { useGroups } from '../api/queries';
import { lastGroup } from './hooks';

/** Where the FAB / "Add expense" goes: current group, else last used, else the first group. */
export function useAddExpenseTarget(): string {
  const location = useLocation();
  const { data: groups } = useGroups();
  const m =
    matchPath('/groups/:id/*', location.pathname) ?? matchPath('/groups/:id', location.pathname);
  const current = m?.params.id && m.params.id !== 'new' ? m.params.id : null;
  const active = groups?.filter((g) => !g.archived) ?? [];
  const last = lastGroup();
  const id =
    current ??
    (last && active.some((g) => g.id === last) ? last : null) ??
    active.toSorted((a, b) => b.lastActivityAt.localeCompare(a.lastActivityAt))[0]?.id ??
    null;
  return id ? `/groups/${id}/expenses/new` : '/groups/new';
}
